import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import AppRouter from './Router/AppRouter';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink, Route, RouterProvider, Routes, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import Login from './Paginas/Login';
import Principal from './Paginas/Principal';
import Dispositivos from './Paginas/Dispositivos';
import Dispositivo from './Paginas/Dispositivo';
import { Usuarios } from './Paginas/Usuarios';
import { Col, Row } from 'react-bootstrap';
import Menu from './Componentes/Menu';
function App() {
 
  

  
  return (
    <AppRouter/>
    // <RouterProvider router={router} />
        
    
    
  );
}

export default App;
